import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import PropTypes from "prop-types"
import { Modal, Input, Row, Col, FormGroup, Label } from "reactstrap"
import { AvField, AvForm, AvInput } from "availity-reactstrap-validation"
import {
  editPollAnswer,
  addPollAnswer,
  addPoll,
  addPollClean,
  editPoll,
  editPollClean,
} from "store/actions"
import ImageUploadModal from "components/Common/ImageUploadModal"
import { CONSTANTS } from "@firebase/util"

const MultiPollQuestionModal = props => {
  const idQuestionType = 1
  const dispatch = useDispatch()
  const [formError, setFormError] = useState(false)
  const [questionName, setQuestionName] = useState("")
  const [pollAnswer1, setPollAnswer1] = useState(undefined)
  const [pollAnswer2, setPollAnswer2] = useState(undefined)
  const [pollAnswer3, setPollAnswer3] = useState(undefined)
  const [pollAnswer4, setPollAnswer4] = useState(undefined)

  console.log(props.question)

  const idQuestion =
    props.question !== undefined ? props.question.idQuestion : 0

  const answers = props.question !== undefined ? props.question.answers : []

  const {
    pollAddLoading,
    pollAddDone,
    pollAddError,
    pollEditLoading,
    pollEditDone,
    pollEditError,
  } = useSelector(store => ({
    pollAddLoading: store.PollAdd.loading,
    pollAddDone: store.PollAdd.done,
    pollAddError: store.PollAdd.error,
    pollEditLoading: store.PollEdit.loading,
    pollEditDone: store.PollEdit.done,
    pollEditError: store.PollEdit.error,
  }))

  useEffect(() => {
    setQuestionName(props.question !== undefined ? props.question.question : "")
    return () => {
      setFormError(false)
    }
  }, [props.question])

  useEffect(() => {
    if (answers.length > 0) {
      setPollAnswer1(answers[0])
      setPollAnswer2(answers[1])
      setPollAnswer3(answers[2])
      setPollAnswer4(answers[3])
    }
    return () => {
      /* setPollAnswer1(undefined)
      setPollAnswer2(undefined)
      setPollAnswer3(undefined)
      setPollAnswer4(undefined) */
    }
  }, [answers])

  console.log(`ANSWER: ${pollAnswer1}`)

  const handleSubmit = async (event, errors, values) => {
    console.log(values)
    if (errors.length > 0) {
      setFormError(true)
      return
    }
    setFormError(false)

    const request = {
      idCourse: props.course.idCurso,
      idQuestionType: idQuestionType,
      question: values.question,
      requested: true,
      isPlataformValoration: false,
    }

    if (props.question === undefined) {
      dispatch(addPoll(request))
    } else {
      request.idQuiz = props.question.idQuiz
      dispatch(editPoll(request))

      if (!(props.question.answers.length > 0)) {
        const requestAnswers = {
          idExamQuestion: props.question.idQuestion,
          List: [
            {
              answer: pollAnswer1.answer,
              image: "",
              correctAnswer: 0,
            },
            {
              answer: pollAnswer2.answer,
              image: "",
              correctAnswer: 0,
            },
            {
              answer: pollAnswer3.answer,
              image: "",
              correctAnswer: 0,
            },
            {
              answer: pollAnswer4.answer,
              image: "",
              correctAnswer: 0,
            },
          ],
        }
        //dispatch(addAnsswers(requestAnswers))
      } else {
        /* dispatch(
          editAnswer({
            idQuestionAnswer: answer1.idQuestionAnswer,
            idExamQuestion: answer1.idQuestion,
            answer: answer1.answer,
            image: "",
            correctAnswer: 0,
          })
        )
        dispatch(
          editAnswer({
            idQuestionAnswer: answer2.idQuestionAnswer,
            idExamQuestion: answer2.idQuestion,
            answer: answer2.answer,
            image: "",
            correctAnswer:0,
          })
        )
        dispatch(
          editAnswer({
            idQuestionAnswer: answer3.idQuestionAnswer,
            idExamQuestion: answer3.idQuestion,
            answer: answer3.answer,
            image: "",
            correctAnswer: 0,
          })
        )
        dispatch(
          editAnswer({
            idQuestionAnswer: answer4.idQuestionAnswer,
            idExamQuestion: answer4.idQuestion,
            answer: answer4.answer,
            image: "",
            correctAnswer: 0,
          })
        )*/
      }
    }
  }

  if (pollAddDone) {
    dispatch(addPollClean())
    props.onConfirm()
  }

  if (pollEditDone) {
    dispatch(editPollClean())
    props.onConfirm()
  }

  return (
    <Modal isOpen={props.show} backdrop={"static"} id="staticBackdrop">
      <AvForm className="form-horizontal" onSubmit={handleSubmit}>
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            Pregunta de encuesta: Opción múltiple
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              if (questionName === "") {
                //dispatch(removeQuestion(idQuestion))
              }
              props.onCancel()
            }}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          {formError && (
            <div className="alert alert-danger">
              Existen errores en el formulario. Por favor corrígelos para
              continuar.
            </div>
          )}
          {pollAddError !== "" && (
            <div className="alert alert-danger">{pollAddError}</div>
          )}
          <Row className="mb-4">
            <Col md={12}>
              <AvField
                name="question"
                label="Ingresa la pregunta"
                className="form-control"
                placeholder="Ingresar"
                value={
                  props.question !== undefined ? props.question.question : ""
                }
                type="text"
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Este campo es requerido",
                  },
                }}
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={12}>
              <Row className="mb-2">
                <Col xs={12} className="d-flex align-items-center">
                  <AvInput
                    name="pollAnswer1"
                    className="form-control"
                    placeholder="Ingresa la respuesta 1"
                    value={pollAnswer1 === undefined ? "" : pollAnswer1.answer}
                    onChange={e =>
                      setPollAnswer1({ ...pollAnswer1, answer: e.target.value })
                    }
                    type="text"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Este campo es requerido",
                      },
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} className="d-flex align-items-center">
                  <AvInput
                    name="pollAnswer2"
                    className="form-control"
                    placeholder="Ingresa la respuesta 2"
                    value={pollAnswer2 === undefined ? "" : pollAnswer2.answer}
                    onChange={e =>
                      setPollAnswer2({ ...pollAnswer2, answer: e.target.value })
                    }
                    type="text"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Este campo es requerido",
                      },
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} className="d-flex align-items-center">
                  <AvInput
                    name="pollAnswer3"
                    className="form-control"
                    placeholder="Ingresa la respuesta 3"
                    value={pollAnswer3 === undefined ? "" : pollAnswer3.answer}
                    onChange={e =>
                      setPollAnswer3({ ...pollAnswer3, answer: e.target.value })
                    }
                    type="text"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Este campo es requerido",
                      },
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} className="d-flex align-items-center">
                  <AvInput
                    name="pollAnswer4"
                    className="form-control"
                    placeholder="Ingresa la respuesta 4"
                    value={pollAnswer4 === undefined ? "" : pollAnswer4.answer}
                    onChange={e =>
                      setPollAnswer4({ ...pollAnswer4, answer: e.target.value })
                    }
                    type="text"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Este campo es requerido",
                      },
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              if (questionName === "") {
                //dispatch(removeQuestion(idQuestion))
              }
              props.onCancel()
            }}
          >
            Cancelar
          </button>
          <button
            type="submit"
            className={`btn btn-secondary ${
              pollAddLoading || pollEditLoading ? "disabled" : ""
            }`}
          >
            {pollAddLoading || pollEditLoading ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </AvForm>
      <style jsx="true">{`
        .noNorder {
          border: 0 !important;
        }
      `}</style>
    </Modal>
  )
}

MultiPollQuestionModal.propTypes = {
  show: PropTypes.bool,
  question: PropTypes.object,
  course: PropTypes.object,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default MultiPollQuestionModal
